/******************************************************************************
 * 
 * Strauss Motion
 * 
 * Copyright (c) 2022 Robimo GmbH
 *
 * Authors: Daniel Martinek
 *
 *****************************************************************************/

import { connect } from 'react-redux'
import { ApplicationState, ProductState } from '../store/interfaces';

import { Orderscreen } from '../components/Orderscreen'
import { configRemoveProduct, configSetBasics, configSetInspectColor, configSetInspectSize, configStoreFetch, configUpdateProduct, uiGoTo, uiSetDetailArticleIndex, uiSetEditScreenTab, uiSetMobileOrderStep, uiSetPreviewArticle1 } from '../store/actions';

const mapStateToProps = (state: ApplicationState) => {
    return {
        ui: state.ui,
        config: state.config,
        library: state.library
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        onUiGoTo: (route: string) => {
            dispatch(uiGoTo(route));
        },
        onUiSetPreviewArticle1: (article: string) => {
            dispatch(uiSetPreviewArticle1(article));
        },
        onUiSetDetailArticleIndex: (detailArticleIndex: number) => {
            dispatch(uiSetDetailArticleIndex(detailArticleIndex));
        },
        onUiSetEditScreenTab: (editScreenTab: string) => {
            dispatch(uiSetEditScreenTab(editScreenTab));
        },
        onUiSetMobileOrderStep: (step: string) => {
            dispatch(uiSetMobileOrderStep(step));
        },
        onConfigSetBasics: (basics: boolean) => {
            dispatch(configSetBasics(basics));
            dispatch(configStoreFetch());
        },
        onConfigSetInspectColor: (inspectColor: boolean) => {
            dispatch(configSetInspectColor(inspectColor));
            dispatch(configStoreFetch());
        },
        onConfigSetInspectSize: (inspectSize: boolean) => {
            dispatch(configSetInspectSize(inspectSize));
            dispatch(configStoreFetch());
        },
        onProductUpdate: (index: number, state: ProductState) => {
            dispatch(configUpdateProduct(index, state));
            dispatch(configStoreFetch());
        },
        onProductRemove: (index: number) => {
            dispatch(configRemoveProduct(index));
            dispatch(configStoreFetch());
        }
    }
}

const OrderscreenContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(Orderscreen)

export default OrderscreenContainer